// 清掃者画面の多言語化（日本語・中文・English）  2026-10-28
//   - 清掃者画面だけで使う辞書（サイト全体の i18n とは分けて、画面を軽く保つ）
//   - 選んだ言語は端末に保存（localStorage 'cleaner_lang'）。初回は端末の言語から決める
//   - サーバーから来る日本語のエラー文は SERVER_MSG で訳す（未登録の文はそのまま表示）
export type Lang = 'ja' | 'zh' | 'en';
export const LANGS: { code: Lang; label: string }[] = [
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文' },
  { code: 'en', label: 'English' },
];
const STORE_KEY = 'cleaner_lang';

export function detectLang(): Lang {
  try {
    const q = new URLSearchParams(window.location.search).get('lng');
    if (q === 'ja' || q === 'zh' || q === 'en') return q;
    const s = window.localStorage.getItem(STORE_KEY);
    if (s === 'ja' || s === 'zh' || s === 'en') return s;
    const n = (navigator.language || '').toLowerCase();
    if (n.startsWith('zh')) return 'zh';
    if (n.startsWith('ja')) return 'ja';
    if (n) return 'en';
  } catch { /* 既定へ */ }
  return 'ja';
}
export function saveLang(l: Lang): void {
  try { window.localStorage.setItem(STORE_KEY, l); } catch { /* 無視 */ }
}

const ja = {
  appName: '清掃担当', headerTitle: '清掃', loading: '読み込み中…', loginId: 'ログインID', pw: 'パスワード', login: 'ログイン', checking: '確認中…',
  cannotConnect: 'サーバーに接続できません', genericErr: 'エラーが発生しました ({s})', logout: 'ログアウト', language: '言語',
  notices: 'お知らせ', noticesAria: 'お知らせ {n}件', readAll: 'すべて既読にする', noNotices: 'お知らせはありません',
  viewDetail: '詳細を見る ›', otherUnread: 'ほかに未読 {n}件', closeNotice: 'このお知らせを閉じる',
  'notice.comment': '管理者からコメントがあります', 'notice.approve': '清掃結果が承認されました', 'notice.reject': '清掃結果が差し戻されました（やり直し）',
  sumToday: '今日の担当', sumLeft: '今日の残り', sumWeek: '1週間の担当', unit: '件', countN: '{n}件',
  'view.week': '本日から1週間', 'view.calendar': 'カレンダー', 'view.open': '未完了',
  refresh: '↻ 最新の情報に更新', pickHint: '清掃を選ぶと、ここに詳細と報告ボタンが表示されます。',
  noTaskDay: 'この日の担当はありません', noOpen: '未完了の清掃はありません 🎉', noTasks: '担当はありません', dayNone: '担当なし',
  today: '今日', tomorrow: '明日', past: '（過ぎています）', withMates: '{names}と担当', sep: '、',
  'st.pending': '未着手', 'st.in_progress': '作業中', 'st.completed': '完了', 'st.needs_review': '要確認',
  noTime: '時間の指定なし', prevMonth: '前の月', nextMonth: '次の月', todayBtn: '今日', dayAria: '{d} 担当{n}件',
  back: '‹ 一覧に戻る', planned: '予定', actual: '実績',
  rejectedTitle: '✖ 管理者から差し戻されました', rejectedText: '下のコメントを確認して作業し直し、もう一度「完了報告」をしてください。',
  approved: '✔ 管理者が承認しました', nextCheckin: '次のチェックイン', sameDay: '当日', assignees: '担当', you: '（あなた）',
  adminNote: '管理者メモ', issueReason: '要確認の理由', reportNote: '報告メモ', supplyCost: '備品代', yen: '{n}円',
  commentsTitle: '管理者からのコメント', 'kind.reject': '✖ 差し戻し', 'kind.approve': '✔ 承認', 'kind.comment': '💬 コメント',
  start: '▶ 作業開始', complete: '✅ 完了報告', issue: '⚠️ 問題を報告（要確認）', doneMsg: '✅ この清掃は完了しています。おつかれさまでした。',
  editHint: '間違えて報告した場合は、今日中なら修正・取り消しができます。', editReport: '✏️ 報告内容を修正', undo: '↩︎ 完了を取り消す',
  startTitle: '作業を開始しますか？', cleaningDate: '清掃日', startTime: '開始時刻', endTime: '終了時刻',
  notTodayWarn: '⚠ 清掃日は{d}です。今日ではありませんが、開始してよろしいですか？', earlyWarn: '⚠ 予定の開始時刻（{t}）より前です。',
  startNote: '「開始する」を押すと、今の時刻が開始時刻として記録されます。', startOk: '開始する', recording: '記録中…', cancel: 'キャンセル',
  completeTitle: '完了報告', editTitle: '報告内容の修正', nowSuffix: '（今）',
  editNote: 'メモと備品代だけ修正できます（時刻は変わりません）。時刻を直したいときは「完了を取り消す」から報告し直してください。',
  noStartWarn: '⚠ 作業開始の記録がないため、開始時刻も今の時刻で記録されます。',
  noteLabel: '連絡メモ', optional: '任意', required: '必須', notePh: '忘れ物・気づいたこと・次の人への連絡など',
  costLabel: '備品購入代金', yenUnit: '円', costErr: '備品代は数字で入力してください', sending: '送信中…',
  saveEdit: '修正を保存する', submitComplete: '完了として報告する',
  checklistTitle: '清掃チェックリスト', checklistHint: 'すべての項目にチェックすると完了報告できます', checklistLeft: 'あと {n} 項目', checklistAll: 'すべてチェック', checklistNeed: 'チェックリストのすべての項目を確認してください', checklistDoneTitle: 'チェックリスト（完了報告時）',
  'photoOnlyBtn': '📷 写真を追加',
  'photoSheetTitle': '写真を追加',
  'photoSheetNote': '清掃前の様子・忘れ物・破損などを、作業の前や途中に送れます。送った写真は完了報告にも残ります。',
  'photoSend': '写真を送る（{n}枚）',
  'photoOnlyFail': '写真{n}枚を送れませんでした。もう一度お試しください。',
  'startPhotoTip': '📷 作業の前に「写真を追加」から清掃前の様子を撮っておけます。',
  'photosLabel': '写真',
  'photosHint': '忘れ物・清掃前・清掃後の様子などを撮って、説明を添えられます。写真なしでも報告できます。',
  'photoAdd': '📷 写真を追加',
  'photoRemove': 'この写真を外す',
  'captionPh': '説明（例：ベッドの下にイヤホンがありました）',
  'pc.before': '清掃前',
  'pc.after': '清掃後',
  'pc.lost': '忘れ物',
  'pc.damage': '破損・汚れ',
  'pc.other': 'その他',
  'photosTitle': '写真（{n}枚）',
  'photoDelete': '写真を削除',
  'photoDelConfirm': 'この写真を削除しますか？',
  'photoFail': '報告は送信しましたが、写真{n}枚を送れませんでした。「報告を修正」から追加し直してください。',
  'photoUploading': '写真を送信中…（{i}/{n}）',
  'photoLimit': '写真は1件の清掃につき{n}枚までです',
  issueTitle: '問題を報告', issueNote: '報告すると「要確認」になり、管理者に知らせます。あとから完了報告もできます。',
  presetsAria: 'よくある内容', issueLabel: '内容', issuePh: '何があったか、どこまで作業したかなど', submitIssue: '要確認として報告する',
  undoTitle: '完了を取り消しますか？', recordedTime: '記録した時刻',
  undo1: '状態が「作業中」に戻ります。', undo2: '終了時刻の記録は消えます（開始時刻・メモ・備品代は残ります）。',
  undo3: '作業が終わったら、もう一度「完了報告」をしてください。', processing: '処理中…', undoOk: '完了を取り消す', keep: 'やめる',
};
export type Key = keyof typeof ja;

const zh: Record<Key, string> = {
  appName: '清洁人员', headerTitle: '清洁', loading: '加载中…', loginId: '登录ID', pw: '密码', login: '登录', checking: '验证中…',
  cannotConnect: '无法连接服务器', genericErr: '发生错误 ({s})', logout: '退出', language: '语言',
  notices: '通知', noticesAria: '通知 {n} 条', readAll: '全部标为已读', noNotices: '暂无通知',
  viewDetail: '查看详情 ›', otherUnread: '另有 {n} 条未读', closeNotice: '关闭此通知',
  'notice.comment': '管理员给你留言了', 'notice.approve': '清洁结果已批准', 'notice.reject': '清洁结果被退回（需要重做）',
  sumToday: '今日任务', sumLeft: '今日剩余', sumWeek: '一周任务', unit: '项', countN: '{n}项',
  'view.week': '今天起一周', 'view.calendar': '日历', 'view.open': '未完成',
  refresh: '↻ 刷新', pickHint: '选择一项清洁任务，这里会显示详情和报告按钮。',
  noTaskDay: '当天没有任务', noOpen: '没有未完成的清洁任务 🎉', noTasks: '没有任务', dayNone: '无任务',
  today: '今天', tomorrow: '明天', past: '（已过期）', withMates: '与{names}一起负责', sep: '、',
  'st.pending': '未开始', 'st.in_progress': '进行中', 'st.completed': '已完成', 'st.needs_review': '需确认',
  noTime: '未指定时间', prevMonth: '上个月', nextMonth: '下个月', todayBtn: '今天', dayAria: '{d} 任务{n}项',
  back: '‹ 返回列表', planned: '计划', actual: '实际',
  rejectedTitle: '✖ 管理员已退回', rejectedText: '请查看下面的留言，重新完成后再次提交“完成报告”。',
  approved: '✔ 管理员已批准', nextCheckin: '下次入住', sameDay: '当天', assignees: '负责人', you: '（你）',
  adminNote: '管理员备注', issueReason: '需确认原因', reportNote: '报告备注', supplyCost: '备品费用', yen: '{n}日元',
  commentsTitle: '管理员留言', 'kind.reject': '✖ 退回', 'kind.approve': '✔ 批准', 'kind.comment': '💬 留言',
  start: '▶ 开始工作', complete: '✅ 完成报告', issue: '⚠️ 报告问题（需确认）', doneMsg: '✅ 此清洁已完成，辛苦了！',
  editHint: '如果报告有误，当天内可以修改或撤销。', editReport: '✏️ 修改报告', undo: '↩︎ 撤销完成',
  startTitle: '要开始工作吗？', cleaningDate: '清洁日期', startTime: '开始时间', endTime: '结束时间',
  notTodayWarn: '⚠ 清洁日期是{d}，不是今天。确定要开始吗？', earlyWarn: '⚠ 还没到计划开始时间（{t}）。',
  startNote: '按“开始”后，当前时间将记录为开始时间。', startOk: '开始', recording: '记录中…', cancel: '取消',
  completeTitle: '完成报告', editTitle: '修改报告', nowSuffix: '（现在）',
  editNote: '只能修改备注和备品费用（时间不变）。如需修改时间，请“撤销完成”后重新报告。',
  noStartWarn: '⚠ 没有开始记录，开始时间也将记录为当前时间。',
  noteLabel: '备注', optional: '选填', required: '必填', notePh: '遗留物品、注意到的情况、给下一位的留言等',
  costLabel: '备品购买费用', yenUnit: '日元', costErr: '备品费用请输入数字', sending: '发送中…',
  saveEdit: '保存修改', submitComplete: '提交完成报告',
  checklistTitle: '清扫检查清单', checklistHint: '勾选全部项目后才能提交完成报告', checklistLeft: '还剩 {n} 项', checklistAll: '全部勾选', checklistNeed: '请确认检查清单的全部项目', checklistDoneTitle: '检查清单（完成报告时）',
  'photoOnlyBtn': '📷 添加照片',
  'photoSheetTitle': '添加照片',
  'photoSheetNote': '可在清扫前或清扫过程中发送清扫前的情况、遗留物品、损坏等照片。已发送的照片会保留在完成报告中。',
  'photoSend': '发送照片（{n}张）',
  'photoOnlyFail': '有{n}张照片未能发送，请重试。',
  'startPhotoTip': '📷 开始前可通过“添加照片”拍下清扫前的情况。',
  'photosLabel': '照片',
  'photosHint': '可拍摄遗留物品、清扫前、清扫后的情况并附上说明。没有照片也可以提交报告。',
  'photoAdd': '📷 添加照片',
  'photoRemove': '移除这张照片',
  'captionPh': '说明（例：床下有一副耳机）',
  'pc.before': '清扫前',
  'pc.after': '清扫后',
  'pc.lost': '遗留物品',
  'pc.damage': '损坏・污渍',
  'pc.other': '其他',
  'photosTitle': '照片（{n}张）',
  'photoDelete': '删除照片',
  'photoDelConfirm': '确定删除这张照片吗？',
  'photoFail': '报告已提交，但有{n}张照片未能发送。请通过“修改报告”重新添加。',
  'photoUploading': '正在发送照片…（{i}/{n}）',
  'photoLimit': '每次清扫最多{n}张照片',
  issueTitle: '报告问题', issueNote: '报告后状态变为“需确认”，并通知管理员。之后仍可提交完成报告。',
  presetsAria: '常见内容', issueLabel: '内容', issuePh: '发生了什么、完成到哪一步等', submitIssue: '提交为需确认',
  undoTitle: '要撤销完成吗？', recordedTime: '记录的时间',
  undo1: '状态将变回“进行中”。', undo2: '结束时间的记录会被删除（开始时间、备注、备品费用会保留）。',
  undo3: '完成后，请再次提交“完成报告”。', processing: '处理中…', undoOk: '撤销完成', keep: '不撤销',
};

const en: Record<Key, string> = {
  appName: 'Cleaning Staff', headerTitle: 'Cleaning', loading: 'Loading…', loginId: 'Login ID', pw: 'Password', login: 'Log in', checking: 'Checking…',
  cannotConnect: 'Cannot connect to the server', genericErr: 'An error occurred ({s})', logout: 'Log out', language: 'Language',
  notices: 'Notifications', noticesAria: '{n} notifications', readAll: 'Mark all as read', noNotices: 'No notifications',
  viewDetail: 'View details ›', otherUnread: '{n} more unread', closeNotice: 'Dismiss this notification',
  'notice.comment': 'New comment from the manager', 'notice.approve': 'Your cleaning was approved', 'notice.reject': 'Your cleaning was sent back (please redo)',
  sumToday: 'Today', sumLeft: 'Left today', sumWeek: 'Next 7 days', unit: '', countN: '{n}',
  'view.week': 'Next 7 days', 'view.calendar': 'Calendar', 'view.open': 'Unfinished',
  refresh: '↻ Refresh', pickHint: 'Select a cleaning task to see its details and report buttons here.',
  noTaskDay: 'No tasks on this day', noOpen: 'No unfinished tasks 🎉', noTasks: 'No tasks', dayNone: 'No tasks',
  today: 'Today', tomorrow: 'Tomorrow', past: ' (past)', withMates: 'With {names}', sep: ', ',
  'st.pending': 'Not started', 'st.in_progress': 'In progress', 'st.completed': 'Done', 'st.needs_review': 'Needs review',
  noTime: 'No time set', prevMonth: 'Previous month', nextMonth: 'Next month', todayBtn: 'Today', dayAria: '{d}, {n} tasks',
  back: '‹ Back to list', planned: 'Planned', actual: 'Actual',
  rejectedTitle: '✖ Sent back by the manager', rejectedText: 'Please read the comment below, redo the work, and submit the completion report again.',
  approved: '✔ Approved by the manager', nextCheckin: 'Next check-in', sameDay: 'Same day', assignees: 'Assigned', you: ' (you)',
  adminNote: "Manager's note", issueReason: 'Reason for review', reportNote: 'Report note', supplyCost: 'Supplies', yen: '¥{n}',
  commentsTitle: 'Comments from the manager', 'kind.reject': '✖ Sent back', 'kind.approve': '✔ Approved', 'kind.comment': '💬 Comment',
  start: '▶ Start work', complete: '✅ Report completion', issue: '⚠️ Report a problem', doneMsg: '✅ This cleaning is complete. Thank you!',
  editHint: 'If you reported by mistake, you can edit or undo it until the end of today.', editReport: '✏️ Edit report', undo: '↩︎ Undo completion',
  startTitle: 'Start work now?', cleaningDate: 'Cleaning date', startTime: 'Start time', endTime: 'End time',
  notTodayWarn: '⚠ The cleaning date is {d}, not today. Start anyway?', earlyWarn: '⚠ It is earlier than the planned start time ({t}).',
  startNote: 'Pressing "Start" records the current time as the start time.', startOk: 'Start', recording: 'Saving…', cancel: 'Cancel',
  completeTitle: 'Completion report', editTitle: 'Edit report', nowSuffix: ' (now)',
  editNote: 'Only the note and supplies cost can be changed (times stay the same). To fix the times, undo the completion and report again.',
  noStartWarn: '⚠ No start was recorded, so the start time will also be set to now.',
  noteLabel: 'Note', optional: 'Optional', required: 'Required', notePh: 'Lost items, things you noticed, notes for the next person',
  costLabel: 'Supplies purchased', yenUnit: 'JPY', costErr: 'Enter the supplies cost as a number', sending: 'Sending…',
  saveEdit: 'Save changes', submitComplete: 'Submit as complete',
  checklistTitle: 'Cleaning checklist', checklistHint: 'Check every item to submit the report', checklistLeft: '{n} item(s) left', checklistAll: 'Check all', checklistNeed: 'Please check every item on the checklist', checklistDoneTitle: 'Checklist (at completion)',
  'photoOnlyBtn': '📷 Add photos',
  'photoSheetTitle': 'Add photos',
  'photoSheetNote': 'Send photos of the room before cleaning, lost items, damage, etc. before or during your work. They stay with your completion report.',
  'photoSend': 'Send photos ({n})',
  'photoOnlyFail': '{n} photo(s) could not be uploaded. Please try again.',
  'startPhotoTip': '📷 Before you start, you can use "Add photos" to record the room before cleaning.',
  'photosLabel': 'Photos',
  'photosHint': 'Take photos of lost items, before/after cleaning, etc. and add a description. You can submit without photos.',
  'photoAdd': '📷 Add photos',
  'photoRemove': 'Remove this photo',
  'captionPh': 'Description (e.g. earphones under the bed)',
  'pc.before': 'Before',
  'pc.after': 'After',
  'pc.lost': 'Lost item',
  'pc.damage': 'Damage / stain',
  'pc.other': 'Other',
  'photosTitle': 'Photos ({n})',
  'photoDelete': 'Delete photo',
  'photoDelConfirm': 'Delete this photo?',
  'photoFail': 'Your report was sent, but {n} photo(s) could not be uploaded. Please add them again from "Edit report".',
  'photoUploading': 'Uploading photos… ({i}/{n})',
  'photoLimit': 'Up to {n} photos per cleaning',
  issueTitle: 'Report a problem', issueNote: 'The task will be marked "Needs review" and the manager will be notified. You can still report completion later.',
  presetsAria: 'Common issues', issueLabel: 'Details', issuePh: 'What happened, how far you got, etc.', submitIssue: 'Submit for review',
  undoTitle: 'Undo completion?', recordedTime: 'Recorded time',
  undo1: 'The status goes back to "In progress".', undo2: 'The end time is cleared (start time, note, and supplies cost are kept).',
  undo3: 'When you finish, submit the completion report again.', processing: 'Processing…', undoOk: 'Undo completion', keep: 'Keep it',
};

export const DICT: Record<Lang, Record<Key, string>> = { ja, zh, en };

// 曜日（日曜始まり）・カレンダーの曜日見出し（月曜始まり）
export const DOW: Record<Lang, string[]> = {
  ja: ['日', '月', '火', '水', '木', '金', '土'],
  zh: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
};
export const CAL_DOW: Record<Lang, string[]> = {
  ja: ['月', '火', '水', '木', '金', '土', '日'],
  zh: ['一', '二', '三', '四', '五', '六', '日'],
  en: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
};
const EN_MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export function monthTitle(lang: Lang, ym: string): string {
  const y = Number(ym.slice(0, 4)), m = Number(ym.slice(5, 7));
  return lang === 'en' ? `${EN_MONTH[m - 1]} ${y}` : `${y}年${m}月`;
}

// 問題報告のよくある内容。管理者は日本語で読むので、日本語以外は（日本語）を併記して入れる
export const ISSUE_PRESETS: { ja: string; zh: string; en: string }[] = [
  { ja: '作業を途中で中断した', zh: '工作中途停止了', en: 'Had to stop partway' },
  { ja: '備品・設備が壊れていた', zh: '备品或设备损坏', en: 'Supplies or equipment broken' },
  { ja: '忘れ物があった', zh: '有客人遗留物品', en: 'Found lost items' },
  { ja: '汚れがひどく時間内に終わらない', zh: '太脏，时间内无法完成', en: 'Too dirty to finish in time' },
  { ja: '鍵・入室のトラブル', zh: '钥匙或进门问题', en: 'Key or entry problem' },
];
export function presetText(lang: Lang, p: { ja: string; zh: string; en: string }): string {
  return lang === 'ja' ? p.ja : `${p[lang]}（${p.ja}）`;
}

// サーバーからの日本語メッセージ → 各言語
const SERVER_MSG: Record<string, { zh: string; en: string }> = {
  'ID またはパスワードが正しくありません': { zh: 'ID或密码不正确', en: 'Incorrect ID or password' },
  'ログイン試行回数が多すぎます。しばらくしてから再度お試しください': { zh: '登录尝试次数过多，请稍后再试', en: 'Too many login attempts. Please try again later.' },
  'チェックリストのすべての項目を確認してください': { zh: '请确认检查清单的全部项目', en: 'Please check every item on the checklist' },
  '清掃予定が見つかりません': { zh: '找不到该清洁任务', en: 'Cleaning task not found' },
  'この清掃はすでに開始または完了しています': { zh: '此清洁已经开始或已完成', en: 'This cleaning has already started or is complete' },
  'この清掃はすでに完了しています': { zh: '此清洁已完成', en: 'This cleaning is already complete' },
  '理由を入力してください': { zh: '请填写原因', en: 'Please enter the reason' },
  'この清掃は報告できない状態です': { zh: '此清洁当前无法报告', en: 'This cleaning cannot be reported right now' },
  '備品代は0〜1,000,000の整数（円）で入力してください': { zh: '备品费用请输入0〜1,000,000的整数（日元）', en: 'Enter the supplies cost as a whole number from 0 to 1,000,000 (JPY)' },
  'この清掃は取り消せません': { zh: '此清洁无法撤销', en: 'This cleaning cannot be undone' },
  'この清掃は変更できません': { zh: '此清洁无法修改', en: 'This cleaning cannot be changed' },
  '管理者が確認済みのため、変更できません。': { zh: '管理员已确认，无法修改。', en: 'The manager has already checked this, so it cannot be changed.' },
  'ほかの担当者が報告したため、変更できません。': { zh: '这是其他负责人提交的报告，无法修改。', en: 'Another staff member submitted this report, so it cannot be changed.' },
  '報告した日を過ぎたため、変更できません。管理者に連絡してください。': { zh: '已过报告当天，无法修改。请联系管理员。', en: 'The report day has passed, so it cannot be changed. Please contact the manager.' },
  'Unauthorized': { zh: '登录已过期，请重新登录', en: 'Your session has expired. Please log in again.' },
};
export function serverMsg(lang: Lang, s: string | null | undefined): string {
  if (!s) return '';
  if (lang === 'ja') return s;
  return SERVER_MSG[s]?.[lang] || s;
}
